import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopyV2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Copy",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M11.8125 1.75H4.8125C4.69647 1.75 4.58519 1.79609 4.50314 1.87814C4.42109 1.96019 4.375 2.07147 4.375 2.1875V4.375H2.1875C2.07147 4.375 1.96019 4.42109 1.87814 4.50314C1.79609 4.58519 1.75 4.69647 1.75 4.8125V11.8125C1.75 11.9285 1.79609 12.0398 1.87814 12.1219C1.96019 12.2039 2.07147 12.25 2.1875 12.25H9.1875C9.30353 12.25 9.41481 12.2039 9.49686 12.1219C9.57891 12.0398 9.625 11.9285 9.625 11.8125V9.625H11.8125C11.9285 9.625 12.0398 9.57891 12.1219 9.49686C12.2039 9.41481 12.25 9.30353 12.25 9.1875V2.1875C12.25 2.07147 12.2039 1.96019 12.1219 1.87814C12.0398 1.79609 11.9285 1.75 11.8125 1.75ZM8.75 11.375H2.625V5.25H8.75V11.375ZM11.375 8.75H9.625V4.8125C9.625 4.69647 9.57891 4.58519 9.49686 4.50314C9.41481 4.42109 9.30353 4.375 9.1875 4.375H5.25V2.625H11.375V8.75Z",
			fill: "currentColor"
		})
	})
});
export default SvgCopyV2;
